import React, { useContext } from 'react';
import classNames from 'classnames';

import DownloadAgreement from '../order_dashboard/orders_table/DownloadAgreement';
import { reformatDate } from '../../../lib/utils/datetime_formatters';
import { UserContext } from '../../../App';

export default function OrderOverview({ order, product, entity }) {
  let statusColor;
  let statusText;
  const { user } = useContext(UserContext);
  const isPaymentPlan = order?.product_type !== 'mambu_loan';

  const status = isPaymentPlan
    ? product?.payment_plan_status.toLowerCase()
    : product?.status.toLowerCase();
  switch (status) {
    case 'paid':
    case 'void':
      statusColor = 'bg-gray-200 text-dark-gray';
      statusText = status;
      break;
    case 'new':
      statusColor = 'text-dark-gray';
      statusText = status;
      break;
    case 'active':
    case 'funded':
      statusColor = 'bg-green-100 text-positive-green';
      statusText = 'Active';
      break;
    default:
      statusColor = 'bg-blue-100 text-primary-blue';
      statusText = status;
      break;
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <div>
          <div className="flex items-center">
            <p className="text-4xl font-avenir-black text-navy-blue">
              Order - {product?.order_key}
            </p>
            <span
              className={classNames(
                'inline-flex items-center rounded-md mx-3 mb-1 px-3 pt-2 py-1.5 uppercase font-avenir-medium tracking-wide',
                statusColor,
              )}
            >
              {statusText}
            </span>
          </div>
          <div className="flex flex-col items-start gap-1 font-avenir-medium text-xl">
            {['superadmin', 'admin'].includes(user?.role) && (
              <a
                href={order?.checkout_url}
                target="_new"
                className="text-primary-blue hover:text-navy-blue mx-1"
              >
                Checkout Session URL
              </a>
            )}
            <div className="flex items-center">
              {product?.mambu_loan_id && (
                <p className="mx-1">{product?.mambu_loan_id} | </p>
              )}
              <p
                className={classNames('capitalize mx-1', {
                  'ph-no-capture': order?.entity_type !== 'company',
                })}
              >
                {entity?.name} |{' '}
              </p>
              <p className="capitalize mx-1">
                Disbursement Date:{' '}
                {reformatDate(
                  isPaymentPlan
                    ? product?.disbursement_date
                    : product?.capture_date,
                )}
              </p>
            </div>
          </div>
        </div>
        <DownloadAgreement
          buttonClass="cursor-pointer rounded bg-light-blue py-2 px-5 text-sm flex items-center font-semibold text-primary-blue shadow-sm hover:bg-navy-blue hover:text-white"
          buttonText={
            isPaymentPlan ? 'Payment Plan Agreement' : 'Loan Agreement'
          }
          order={order}
        />
      </div>
    </div>
  );
}
